import { LOGIN } from "./../enums/enums";
import { Component, ViewChild } from "@angular/core";
import { Nav, Platform, MenuController, IonicApp, Events } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { Push, PushObject, PushOptions } from "@ionic-native/push";
import { CodePush, InstallMode } from "@ionic-native/code-push";

import { TranslateService } from "ng2-translate";

import { LoginPage } from "../pages/login/login";
import { ProjectsPage } from "../pages/projects/projects";
import { EmployeesPage } from "../pages/employees/employees";
import { TimeRegistrationsPage } from "../pages/time-registrations/time-registrations";
import { EmployeeDetailsPage } from "../pages/employees/employee-details/employee-details";

import { Login } from "../providers/login";
import { EmployeeData } from "../providers/employee-data";
import { Storage } from "@ionic/storage";
import { Jobrole } from "../enums/enums";
import { SettingsPage } from "../pages/settings/settings";
import { TimeRegistrationsPeriodPage } from "../pages/time-registrations-period/time-registrations-period";
import { JwtHelperService } from "@auth0/angular-jwt";
import { ILogin } from "../model/top.model";

// declare var cordova;
@Component({
  templateUrl: "app.html",
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  enableSplitPane: boolean;
  rootPage: any;
  pages: Array<{
    title: any;
    component: any;
    selected: boolean;
  }>;
  userLanguage: string;
  routeHistory: Array<any>;
  // triggerDate: Date;

  constructor(
    public menu: MenuController,
    private ionicApp: IonicApp,
    private events: Events,
    public platform: Platform,
    private employeeData: EmployeeData,
    public loginProvider: Login,
    public storage: Storage,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public translate: TranslateService,
    private push: Push,
    private codePush: CodePush,
    private jwtHelper: JwtHelperService
  ) {
    this.enableSplitPane = false;
    this.routeHistory = [];
    this.pages = [];
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      // this.setupBrowserBackButtonBehavior();

      // For now alwaye use 'en'.
      // let userLang = navigator.language.split('-')[0]; // use navigator lang if available
      // this.userLanguage = /(fr|en|es|in|zh)/gi.test(userLang) ? userLang : 'en';
      this.userLanguage = "nl";

      // this language will be used as a fallback when a translation isn't found in the current language
      this.translate.setDefaultLang(this.userLanguage);

      this.setLanguage("nl");

      this.login();
      this.events.subscribe("login", (username, password) =>
        this.login(username, password)
      );

      if (this.platform.is("cordova")) {
        this.checkCodePush();
      }
    });
  }

  checkCodePush() {
    const downloadProgress = (progress) => {
      console.log(
        `Bezig met downloaden, ${progress.receivedBytes} van ${progress.totalBytes} gedownload`
      );
    };
    const depKey = this.platform.is("android")
      ? "P5kVoypmmsHZz8VdQIVprkCVmhUZaxh8kVyNeX"
      : "MFHKIgyPbibehgHOqPwnrAXvPV0RI-kaRMrCao";
    this.codePush
      .sync(
        {
          // updateDialog: {
          //     appendReleaseDescription: true,
          //     descriptionPrefix: "\n\nWijzigingen:\n",
          // },
          deploymentKey: depKey,
          installMode: InstallMode.IMMEDIATE,
        },
        downloadProgress
      )
      .subscribe(
        (syncStatus) => {
          console.log("CODE PUSH SYNCSTATUS: " + syncStatus);
        },
        (error) => {
          console.error("CODE PUSH ERROR: " + error);
        }
      );
  }

  initPush(employeeId: string) {
    // const today = new Date();
    // const hours = today.getHours();
    // const minutes = today.getMinutes();
    // const dayOfWeek = today.getDay();
    // let addDays = 0;
    // // calculate days to add for first friday 16:30
    // if (dayOfWeek == 0) {
    //   // sunday
    //   addDays = 5;
    // } else if (dayOfWeek < 5) {
    //   // monday till thursday
    //   addDays = (5 - dayOfWeek);
    // } else if (dayOfWeek == 5) {
    //   // friday
    //   if (hours <= 16) {
    //     if (hours == 16 && minutes >= 30) {
    //       addDays = 7;
    //     }
    //   } else {
    //     addDays = 7;
    //   }
    // } else {
    //   // saturday
    //   addDays = 6;
    // }

    // this.triggerDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 16, 30, 0, 0);
    // this.triggerDate.setDate(this.triggerDate.getDate() + addDays);
    // this.localNotifications.schedule({
    //   text: 'Vergeet niet je uren in te vullen!!!!',
    //   trigger: { firstAt: new Date(new Date().getTime() + 3600) },
    //   every: "week",
    //   led: 'FF0000',
    //   sound: 'res://platform_default',
    //   foreground: true
    // });

    // cordova.plugins.notification.local.schedule({
    //   text: 'Vergeet niet je uren in te vullen!!!!',
    //   trigger: { firstAt: new Date(new Date().getTime() + 10000), every: "week"},
    //   led: 'FF0000',
    //   sound: 'res://platform_default',
    //   foreground: true
    // });

    const pushOptions: PushOptions = {
      android: {
        senderID: "677252788495",
        icon: "icon",
      },
      ios: {
        senderID: "677252788495",
        alert: "true",
        badge: "true",
        sound: "true",
      },
      windows: {},
    };

    var pushObject: PushObject = this.push.init(pushOptions);
    if (pushObject && pushObject.on && pushObject.on instanceof Function) {
      pushObject.on("registration").subscribe((data) => {
        //console.log('Registration parent' + JSON.stringify(data));
        this.employeeData.saveRegistrationId(employeeId, data.registrationId);
      });

      pushObject.on("notification").subscribe((data) => {
        //console.log('Notification guestparent' + JSON.stringify(data));
        if (data.additionalData.foreground) {
          alert(data.message);
        }
      });

      pushObject.on("error").subscribe((e) => {
        console.log("push error guestparent: " + JSON.stringify(e));
        alert(e.message);
      });
    }
  }

  setLanguage(language) {
    this.userLanguage = language;
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use(language);
  }

  initPages(roles: Jobrole[]) {
    this.pages = [
      // {
      //   title: "DASHBOARDS",
      //   component: DashboardsPage,
      //   selected: true
      // },
      {
        title: "MY_HOURS",
        component: [EmployeeDetailsPage, { isTimeRegistration: true }],
        selected: true
      },
    ];
    if (
      roles.indexOf(Jobrole.administrator) > -1 ||
      roles.indexOf(Jobrole.secretariaat) > -1
    ) {
      this.pages.push({
        title: "PROJECTS",
        component: [ProjectsPage],
        selected: false
      });
    }

    if (
      roles.indexOf(Jobrole.administrator) > -1 ||
      roles.indexOf(Jobrole.loonadministratie) > -1 ||
      roles.indexOf(Jobrole.directie) > -1 ||
      roles.indexOf(Jobrole.secretariaat) > -1
    ) {
      this.pages.push({
        title: "EMPLOYEES",
        component: [EmployeesPage],
        selected: false
      });
    }
    if (
      roles.indexOf(Jobrole.administrator) > -1 ||
      roles.indexOf(Jobrole.directie) > -1 ||
      roles.indexOf(Jobrole.fiatteur) > -1 ||
      roles.indexOf(Jobrole.urencontrole) > -1 ||
      roles.indexOf(Jobrole.loonadministratie) > -1
    ) {
      this.pages.push({
        title: "TIME_REGISTRATIONS",
        component: [TimeRegistrationsPage],
        selected: false
      });
    }
    if (
      roles.indexOf(Jobrole.directie) > -1 ||
      roles.indexOf(Jobrole.loonadministratie) > -1
    ) {
      this.pages.push({
        title: "TIME_REGISTRATIONS_PERIODS",
        component: [TimeRegistrationsPeriodPage],
        selected: false
      });
    }
    this.pages.push({
      title: "SETTINGS",
      component: [SettingsPage],
      selected: false
    });
  }

  login(username?, password?) {
    if (username && password) {
      this.loginProvider.login(username, password).then((loginResult) => {
        if (!loginResult.error) {
          this.employeeData.jobRoles = loginResult["jobroles"];
          this.employeeData.loggedInEmployeeId = loginResult["employee_id"];
          this.initPages(loginResult["jobroles"]);
          if (this.platform.is("cordova")) {
            this.initPush(this.employeeData.loggedInEmployeeId);
          }
          this.enableSplitPane = true;
          this.nav.setRoot(EmployeeDetailsPage, { isTimeRegistration: true });
        } else {
          this.nav.setRoot(LoginPage, {
            errorMessage: loginResult.error['errorMessage'],
          });
        }
      });
    } else {
      //if already logged in skip login page
      this.storage.get(LOGIN.LOGIN_OBJECT).then((_login: ILogin) => {
        if (_login && _login.token) {
          const loginResult = this.jwtHelper.decodeToken(_login.token);
          this.employeeData.jobRoles = loginResult.jobroles;
          this.employeeData.loggedInEmployeeId = loginResult.employee_id;
          this.initPages(loginResult.jobroles);
          if (this.platform.is("cordova")) {
            this.initPush(this.employeeData.loggedInEmployeeId);
          }
          this.enableSplitPane = true;
          this.nav.setRoot(EmployeeDetailsPage, { isTimeRegistration: true });
        } else {
          this.nav.setRoot(LoginPage, {
            errorMessage: "Niet ingelogd",
          });
        }
      });
    }
  }

  logout() {
    this.storage.remove(LOGIN.LOGIN_OBJECT).then((result) => {
      //reset pages
      this.pages = [];
      this.nav.setRoot(LoginPage);
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.pages.forEach(pageItem => pageItem.selected = pageItem === page);
    this.nav.setRoot(page.component[0],page.component[1]);
  }

  private pushRouteHistory(page: any): void {
    let component: any = page;

    if (page.component) {
      component = page.component;
    }

    if (
      this.routeHistory.length === 0 ||
      (this.routeHistory.length > 0 &&
        this.routeHistory[this.routeHistory.length - 1] !== component)
    ) {
      this.routeHistory.push(component);
    }
  }

  private setupBrowserBackButtonBehavior(): void {
    window.onpopstate = (event) => {
      console.log("<- Back Button Pressed");

      if (this.menu.isOpen()) {
        this.menu.close();
        return;
      }

      if (this.ionicApp) {
        let activePortal: any =
          this.ionicApp._loadingPortal.getActive() ||
          this.ionicApp._modalPortal.getActive() ||
          this.ionicApp._toastPortal.getActive() ||
          this.ionicApp._overlayPortal.getActive();

        if (activePortal) {
          activePortal.dismiss();
          return;
        }
      }

      if (this.routeHistory.length > 1) {
        this.routeHistory.pop();

        if (this.nav.canGoBack()) {
          this.nav.pop().catch((reason) => {
            console.log("Unable to navigate back:" + reason);
          });
        } else {
          this.nav.setRoot(this.routeHistory[this.routeHistory.length - 1]);
        }
      }
    };

    this.nav.viewWillEnter.subscribe((page) => {
      this.pushRouteHistory(page);
    });

    this.nav.viewDidEnter.subscribe((app) => {
      if (this.routeHistory.length > 1) {
        history.pushState(null, null, "");
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts